// extracted by mini-css-extract-plugin
module.exports = {"studentGuide":"styles-module--studentGuide--QaYtp","sectionTitle":"styles-module--sectionTitle--2KqA8"};